// NATIVE 
import { useEffect, useState } from 'react';

// INSTALLED 
import { useDispatch, useSelector } from 'react-redux';
import { Grid, IconButton, Tooltip } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

// CUSTOM 
import InputField from '../../formFields/InputField';
// import { getFormsDataS } from '../../../store/company';
import InputNumeric from '../../formFields/InputNumeric';
import CheckboxField from '../../formFields/checkBoxField';
import { IDatosBasicos } from '../../../commons/interfaces';
import AutocompleteField from '../../formFields/autocompleteField';
import DatePickerDefaultField from '../../formFields/datePickerDefaultField';
import AutocompleteFieldCountry from '../../formFields/autocompleteFieldCountry';
import AutocompleteFieldDepartament from '../../formFields/AutocompleteFieldDepartament';
import { useFormikContext } from 'formik';


// import InputNumeric from '../formFields';

export const EditarDatosClientes = (props:any) => {


    const dispatch = useDispatch();

    const formikProps:any = useFormikContext();

    // REDUX
    const { countries_list }:IDatosBasicos  = useSelector( (state:any) => state.company );
    const { departaments_list }:any = useSelector( (state:any) => state.departaments );
    const { municipaly_list }:any = useSelector( (state:any) => state.municipalies );
    
    // REDUX 
    const { customer }:any  = useSelector( (state:any) => state.customer );


    const [countries,      setCountries]     = useState([]);
    const [departaments,   setDepartaments]  = useState([]);
    const [municipalies,   setMunicipalies]  = useState([]);


    const { formField: {
        // DATOS CLIENTE 
        e_name,
        e_address,
        e_email,
        e_person_in_charge,
        e_contact,
        e_second_person_in_charge,
        e_second_customer_contact,
        e_phone,
        e_start_date,
        e_status,
        e_country,
        e_departament,
        e_municipaly
      }
    } = props;


    useEffect(() => {
        getDataInputesForm();
     }, []);
 
 
     useEffect(() => {
       setDepartaments(departaments_list);
     }, [departaments_list]);
 
     useEffect(() => {
       setMunicipalies(municipaly_list);
     }, [municipaly_list]);


     const getDataInputesForm = async () => {

        // const response = await dispatch( getFormsDataS() );

        
        setCountries([]);
        setDepartaments([]);
        setMunicipalies([]);
    }


    useEffect(() => {
        setData(customer);
    }, [customer]);



    const setData = (customer:any) => {



      // ID CUSTOMER 
      formikProps.setFieldValue('customerId', customer.id );

      // DATOS BASICOS
      formikProps.setFieldValue('e_name', customer.name);
      formikProps.setFieldValue('e_address', customer.address );
      formikProps.setFieldValue('e_email', customer.email );
      formikProps.setFieldValue('e_person_in_charge', customer.person_in_charge );
      formikProps.setFieldValue('e_contact', customer.contact );
      formikProps.setFieldValue('e_second_person_in_charge', customer.second_person_in_charge );
      formikProps.setFieldValue('e_second_customer_contact', customer.second_customer_contact );
      formikProps.setFieldValue('e_phone', customer.phone );
      formikProps.setFieldValue('e_start_date', customer.start_date );
      formikProps.setFieldValue('e_status', customer.status );
      formikProps.setFieldValue('e_country', customer.pais );
      formikProps.setFieldValue('e_departament', customer.departamento );
      formikProps.setFieldValue('e_municipaly', customer.municipio );
    }

  return (
    <div>

        <Grid container spacing={2}>
            <Grid item xs={3}>
              <InputField 
                name={e_name.name}
                label={e_name.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            
            <Grid item xs={3}>
            <InputField 
                name={e_person_in_charge.name}
                label={e_person_in_charge.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>

            <Grid item xs={3}>
              <InputField 
                name={e_email.name}
                label={e_email.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>

            


            <Grid item xs={3}>
              <InputNumeric 
                name={e_contact.name}
                label={e_contact.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            
            
        </Grid> 
        {/* END GRID  */}

        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid item xs={3}>
                  <AutocompleteFieldCountry
                      options={countries_list}
                      name={e_country.name}
                      label={e_country.label}
                      element={e_country.name}
                  />
            </Grid>
            <Grid item xs={3}>
                  <AutocompleteFieldDepartament 
                      options={departaments}
                      name={e_departament.name}
                      label={e_departament.label}
                      element={e_departament.name}
                  />
            </Grid>
            <Grid item xs={3}> 
                  <AutocompleteField 
                      options={municipaly_list}
                      name={e_municipaly.name}
                      label={e_municipaly.label}
                      element={e_municipaly.name}
                  />
            </Grid>
            <Grid item xs={3}>
              <InputField 
                name={e_address.name}
                label={e_address.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            
        </Grid> 
        {/* END GRID  */}


        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid item xs={3}>
              <InputField 
                name={e_second_person_in_charge.name}
                label={e_second_person_in_charge.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            
            <Grid item xs={2}>
              <InputNumeric 
                name={e_second_customer_contact.name}
                label={e_second_customer_contact.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>


            <Grid item xs={3}>
              
              <DatePickerDefaultField label={e_start_date.label} 
                               name={e_start_date.name}/>
            </Grid> 

            <Grid item xs={2}>
              <InputNumeric 
                name={e_phone.name}
                label={e_phone.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>

             

            <Grid item xs={2} >
                  <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                  <CheckboxField  name={e_status.name} label={e_status.label}/>
                  <Tooltip title='El cliente esta activo o inactivo.'>
                    <IconButton>
                      <HelpOutlineOutlinedIcon color='primary'/>
                    </IconButton>
                  </Tooltip>
                  </div>
            </Grid>
            
            
        </Grid> 
        {/* END GRID  */}

    </div>
  )
}

